export const GetUserRelation = async (userid: string, viewerid: string) =>
  fetch(`/api/public/relation/${userid}/${viewerid}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());

export const GetUserCount = async (userid: string) =>
  fetch(`/api/public/user/${userid}/count`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());

export const GetUserBoards = async (userid: string) =>
  fetch(`/api/public/user/${userid}/boards/all`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());

export const GetUserBoardsContainingToken = async (userName: string, tokenId: string) =>
  fetch(`/api/user/${userName}/boards/${tokenId}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());

export const GetUserUnsignCollaborations = async (userid: string, startTime: number) =>
  fetch(`/api/public/user/${userid}/collaborations?unsigned=true&maxtime=${startTime}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());
